export default class ajaxHrefExtension {
	constructor(naja) {
		naja.addEventListener('init', function () {
			document.addEventListener('click', function (e) {
				let target = e.target;
				if (target.hasAttribute('data-ajax-href')) {
					e.preventDefault();

					let link = target.getAttribute('data-ajax-href');
					if (link.length > 0) {
						naja.makeRequest('GET', link);
					}
				}
			});
		});
	}
}